<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/ImpDates/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>